module.exports = __webpack_public_path__ + "static/media/notepad.8da5ace9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/notepad.png
// module id = 160
// module chunks = 0